import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// These named heights belong to the shared Tailwind theme. Recognizing them
// lets an intentional h-auto override grow with wrapped or enlarged text.
const mergeThemeClasses = extendTailwindMerge({
  extend: { classGroups: { h: [{ h: ["control", "control-small"] }] } },
});

export function cn(...inputs: ClassValue[]) {
  return mergeThemeClasses(clsx(inputs));
}
